import { render, staticRenderFns } from "./observe-list.vue?vue&type=template&id=0fd5c577&scoped=true&"
import script from "./observe-list.vue?vue&type=script&lang=js&"
export * from "./observe-list.vue?vue&type=script&lang=js&"
import style0 from "./observe-list.vue?vue&type=style&index=0&id=0fd5c577&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd5c577",
  null
  
)

export default component.exports